import PUApi from './_puApi';
import httpClient from '@/apis/base/httpclient';

class PUInvoiceAPI extends PUApi {
  constructor() {
    super();
  }
  controllerName = 'PuInvoices';

  /**
   * Xem số lượng tồn vật tư
   * NTLOC 12.08.2022
   */
  getListInventoryQuantity(param) {
    let request = {
      url: this.getAPIUrl() + '/inventoryQuantity',
      data: param,
    };

    return httpClient.postAsync(request);
  }

  /**
   * Xem số lượng tồn vật tư
   * NTLOC 12.08.2022
   */
  getInventoryQuantity(param) {
    let request = {
      url: this.getAPIUrl() + '/inventoryQuantityList',
      data: param,
    };

    return httpClient.postAsync(request);
  }

  // Xem chứng từ chưa thnah toán hết
  // lttuan1 - 23.02.2023
  getRefNoInvoice(accountingObjectID) {
    const url = this.getAPIUrl() + '/RefNoInvoice';
    const data = { accountingObjectID };
    const request = { url, data };
    return this.getAsync(request);
  }
  /**
   * Lấy dữ liệu danh sách công nợ phải trả
   */
  getListPUInvoice(payload){
    let request = {
      url: this.getAPIUrl() + '/SelectRefNoInvoice',
      data: payload,
    };
    return httpClient.postAsync(request);
  }
  /**
   * Lấy dữ liệu danh sách công nợ phải trả
   */
  getListSummaryPUInvoice(payload){
    let request = {
      url: this.getAPIUrl() + '/SelectRefNoInvoice',
      data: payload,
    };
    return httpClient.postAsync(request);
  }
}

export default new PUInvoiceAPI();
